import { DRAW_MODAL } from 'src/reducers/modal/types';
import { REGULATORY_ACCEPT } from 'src/reducers/oauth/types';

import { urls } from 'Utilities/dataHelpers';
import log from 'Utilities/log';
import mediator from 'Utilities/mediator';
import { getSessionObject } from 'Utilities/storage';
import { store } from 'Utilities/store';

import { ERROR_FORGOT_PASSWORD_VALIDATE } from 'Constants/errorTypes';
import {
  CONSENT_INFO_MODAL,
  FORGOT_PASSWORD_MODAL,
  REGULATORY_ACCEPT_MODAL,
} from 'Constants/modalTypes';

const handleLogin = (request: any) => {
  const challenge = getSessionObject('login_challenge');

  request.response = new Promise((resolve, reject) => {
    mediator
      .request<OauthGen>('api:invoke', {
        method: 'PUT',
        url: urls.lslApi + 'oauth2/api/login/accept',
        data: {
          password: request.password,
          username: request.username,
          challenge,
        },
      })
      .then((result) => {
        if (result.status === 0) {
          window.location.assign(result.data.redirect_to);
        } else if ([1, 2, 3].includes(result.status)) {
          result.error = result.error || { message: '' };

          log.debug('Response error message: ', result.error.message); // Log response message since it's being overwritten

          if (result.status === 3) {
            result.error.message = 'Auth.regionUnavailable';
          } else {
            result.error.message = 'Auth.loginFailure';
          }
        }

        resolve(result);
      })
      .catch((err) => {
        log.error(err);
        reject(err);
      });
  });
};

const handleConsentInfo = (request: any) => {
  store.dispatch({
    type: DRAW_MODAL,
    modal: CONSENT_INFO_MODAL,
    props: { scope: request.scope },
  });
};

const handleAcceptConsent = (request: any) => {
  const challenge = getSessionObject('consent_challenge');

  request.response = new Promise((resolve, reject) => {
    mediator
      .request<OauthGen>('api:invoke', {
        method: 'PUT',
        url: urls.lslApi + 'oauth2/api/consent/accept',
        data: {
          granted_scopes: request.acceptedScopes,
          challenge,
        },
      })
      .then((result) => {
        if (result.status === 0) {
          window.location.assign(result.data.redirect_to);
          resolve(result);
        } else {
          resolve(result);
        }
      })
      .catch((err) => {
        log.error(err);
        reject(err);
      });
  });
};

const handleAcceptRegulatory = (request: Record<string, string[]>) => {
  request.agreements.shift();

  store.dispatch({
    type: REGULATORY_ACCEPT,
    agreements: request.agreements.length === 0 ? undefined : request.agreements,
  });
};

const handleRejectConsent = (request: any) => {
  const challenge = getSessionObject('consent_challenge');

  request.response = new Promise((resolve, reject) => {
    mediator
      .request<OauthGen>('api:invoke', {
        method: 'PUT',
        url: urls.lslApi + 'oauth2/api/consent/reject',
        data: {
          challenge,
        },
      })
      .then((result) => {
        if (result.status === 0) {
          window.location.assign(result.data.redirect_to);
          resolve(result);
        } else {
          // TODO: what do we do if reject fails?
          resolve(result);
        }
      })
      .catch((err) => {
        // TODO: what do we do if reject fails?
        log.error(err);
        reject(err);
      });
  });
};

const handleRegulatoryAcceptModal = (request: Record<string, unknown>) => {
  store.dispatch({
    type: DRAW_MODAL,
    modal: REGULATORY_ACCEPT_MODAL,
    props: { ...request },
  });
};

const forgotPasswordReset = (request: any) => {
  request.response = new Promise((resolve, reject) => {
    mediator
      .request<LVApiResponse>('api:invoke', {
        method: 'POST',
        url: urls.lslApi + 'auth/forgotPassword',
        data: {
          email: request.username,
        },
      })
      .then((result) => {
        if (result.status !== 0) {
          mediator.publish('error:display', {
            error: {
              code: result.status,
              type: ERROR_FORGOT_PASSWORD_VALIDATE,
            },
          });
        } else {
          mediator.publish('oauth:forgotPasswordModal');
        }

        resolve(result);
      })
      .catch((err) => {
        log.error(err);
        mediator.publish('error:display', {
          error: {
            code: err.status,
            type: ERROR_FORGOT_PASSWORD_VALIDATE,
          },
        });
        reject(err);
      });
  });
};

const handleForgotPasswordModal = () => {
  store.dispatch({
    type: DRAW_MODAL,
    modal: FORGOT_PASSWORD_MODAL,
  });
};

mediator.subscribe('oauth:login', handleLogin);
mediator.subscribe('oauth:consentInfo', handleConsentInfo);
mediator.subscribe('oauth:acceptConsent', handleAcceptConsent);
mediator.subscribe('oauth:rejectConsent', handleRejectConsent);
mediator.subscribe('oauth:acceptRegulatory', handleAcceptRegulatory);
mediator.subscribe('oauth:regulatoryAcceptModal', handleRegulatoryAcceptModal);
mediator.subscribe('oauth:forgotPasswordReset', forgotPasswordReset);
mediator.subscribe('oauth:forgotPasswordModal', handleForgotPasswordModal);
